import React from 'react';
import s from '../../pages/PDV.module.css';

export default function ModalCorrecaoFiscal({ modalCorrecao, setModalCorrecao, resultadoDocMov, correcoes, setCorrecoes, salvandoCorrecao, salvarEReemitir, correcaoTipo }) {
  if (!modalCorrecao) return null;
        const CAMPOS_CFG = {
          NCM:   { campo: 'ncm',        label: 'NCM',            placeholder: '12345678' },
          CFOP:  { campo: 'cfop_saida', label: 'CFOP de Saída',  placeholder: '5102' },
          CSOSN: { campo: 'csosn',      label: 'CSOSN',          placeholder: '102' },
          CEST:  { campo: 'cest',       label: 'CEST (ICMS-ST)', placeholder: '1001000' },
        };
        const produtos = (resultadoDocMov?.detalhes_fiscais || []).filter(d => d.produto_id);
        return (
          <div className={s.correcaoOverlay} onClick={() => !salvandoCorrecao && setModalCorrecao(false)}>
            <div className={s.correcaoModal} onClick={e => e.stopPropagation()}>
              <div className={s.correcaoTitulo}>
                ✏️ Corrigir Dados Fiscais
                <button className={s.modalClose} onClick={() => setModalCorrecao(false)}>✕</button>
              </div>
              <div className={s.correcaoCorpo}>
                {produtos.map(d => (
                  <div key={d.produto_id} className={s.correcaoProduto}>
                    <div className={s.correcaoProdNome}>{d.produto}</div>
                    <div className={s.correcaoCampos}>
                      {d.campos_faltando.map(c => {
                        const cfg = CAMPOS_CFG[c];
                        if (!cfg) return null;
                        return (
                          <label key={c} className={s.correcaoLabel}>
                            <span>{cfg.label}</span>
                            <input
                              className={s.correcaoInput}
                              placeholder={cfg.placeholder}
                              value={correcoes[d.produto_id]?.[cfg.campo] || ''}
                              onChange={e => setCorrecoes(prev => ({
                                ...prev,
                                [d.produto_id]: { ...prev[d.produto_id], [cfg.campo]: e.target.value },
                              }))}
                            />
                          </label>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
              <div className={s.correcaoRodape}>
                <button
                  className={s.movBtnFiscal}
                  disabled={salvandoCorrecao}
                  onClick={salvarEReemitir}
                >
                  {salvandoCorrecao ? 'Salvando…' : `💾 Salvar e Emitir ${correcaoTipo === 'nfce' ? 'NFC-e' : 'NF-e'}`}
                </button>
                <button className={s.f3BtnSair} disabled={salvandoCorrecao}
                  onClick={() => setModalCorrecao(false)}>
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        );
}
